/**
 * Generated bundle index. Do not edit.
 */

export {NgxFlatpickrkModule} from './index';

export {FlatPickrComponent as ɵa} from './src/component/flatpickr.component';